import React, { Component, Fragment } from "react";

import DocumentMeta from "react-document-meta";

import * as actions from "../../actions";
import { connect } from "react-redux";

import FeedbackItem from "../FeedbackItem";
import ContentHeader from "../layout/ContentHeader";
import PanelWrapper from "../layout/PanelWrapper";
import LoadBarButton from "../LoadBarButton";
import Error from "../Error";

class FeedbackContent extends Component {
  componentDidMount() {
    if (!this.props.content.initialLoadComplete) {
      this.props.initialLoadFeedback(this.props.content.offset);
    }
  }

  loadMoreReviews() {
    if (!this.props.content.loading) {
      this.props.initialLoadFeedback(this.props.content.offset);
    }
  }

  render() {
    let items = this.props.content.feedback.map(value => {
      return (
        <FeedbackItem
          reviewer={value.acf.name}
          date={value.acf.date}
          reviewText={value.acf.review_text}
          link={value.acf.link}
          key={value.id}
        />
      );
    });

    const meta = {
      title: "Feedback - Arthur Perfect Job",
      description:
        "Customer feedback for Arthur Perfect Job. Plumbing, Demolition, Carpentry / Joinery, Electrics, Plastering / Rendering, Flooring, Drylining, Painting and Decorating, Suspended Ceilings, Handyman Service, Partition walls, Tiling.",
      meta: {
        charset: "utf-8",
        name: {
          keywords:
            "plumbing,demolition,carpentry,joinery,electrics,plastering,rendering,flooring,drylining,painting,decorating,suspended,ceilings,handyman,service,partition,walls,tiling.",
          "og:title": "Feedback - Arthur Perfect Job",
          "og:img": "https://apjhomerenovation.co.uk/img/opengraph.jpg",
          "og:type": "website"
        }
      }
    };

    return (
      <Fragment>
        <DocumentMeta {...meta} />
        <ContentHeader
          title="FEEDBACK"
          description="Feedback from the customers of Arthur Perfect Job"
        />

        {this.props.content.error ? <Error /> : null}

        {this.props.content.initialLoadComplete ? items : null}

        {this.props.content.feedback.length < this.props.content.maxTotal ? (
          <PanelWrapper
            color={
              this.props.content.loading
                ? "rgba(0,0,0,0.85)"
                : "rgba(253,186,3,0.85)"
            }
            padding="0"
          >
            <LoadBarButton
              text="Load More Reviews"
              clickAction={this.loadMoreReviews.bind(this)}
              loading={this.props.content.loading}
            />
          </PanelWrapper>
        ) : null}
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  return { content: state.feedback };
}

export default connect(
  mapStateToProps,
  actions
)(FeedbackContent);



// WEBPACK FOOTER //
// ./src/components/pages/FeedbackContent.js